import React, { useEffect } from "react";
import PageHeader from "../components/PageHeader";

const Elpa: React.FC = () => {
  useEffect(() => {
    document.title = "CO.ME.ST. S.R.L - Elpa";
  }, []);

  return (
    <div className="antialiased text-gray-800 bg-gray-50">
      <PageHeader title="Elpa Solutions" breadcrumb="Elpa" />

      {/* Page Content */}
      <div className="bg-gradient-to-b from-white to-gray-50">
        <div className="container px-4 py-12 mx-auto sm:px-6 lg:px-8 sm:py-16">
          {/* Intro Section */}
          <section className="mb-16 text-center md:mb-20">
            <img
              src="/images/elpa.png"
              alt="Elpa Solutions Logo"
              className="mx-auto mb-8 h-24"
            />
            <h2 className="mb-4 text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl">
              Esperti in Stampi per Lamiera e Alluminio
            </h2>
            <p className="mx-auto max-w-3xl text-lg text-gray-600 sm:text-xl">
              Con anni di esperienza consolidata, siamo leader nella costruzione
              di stampi per lamiera e alluminio, servendo con orgoglio il settore della
              componentistica per auto e non solo.
            </p>
          </section>

          {/* Core Activities Section */}
          <section className="mb-16 md:mb-20">
            <div className="mb-12 text-center">
              <h3 className="text-3xl font-bold text-gray-900 sm:text-4xl">
                Le Nostre Specializzazioni
              </h3>
              <p className="mx-auto mt-3 max-w-2xl text-lg text-gray-500">
                Dalla concezione alla realizzazione, il nostro processo è
                guidato dalla precisione e dall'innovazione.
              </p>
            </div>
            <div className="grid gap-8 text-left md:grid-cols-3">
              <div className="p-8 bg-white rounded-xl shadow-lg transition-shadow duration-300 transform hover:shadow-2xl hover:-translate-y-1">
                <h4 className="mb-3 text-xl font-semibold text-indigo-700">
                  Studi di Fattibilità
                </h4>
                <p className="mb-4 text-gray-600">
                  Analisi approfondite di fattibilità e imbutibilità realizzate
                  in-house per garantire la massima efficienza e qualità del
                  prodotto finale.
                </p>
                <video 
                  className="object-cover w-full h-48 rounded-lg"
                  autoPlay
                  loop
                  muted
                  playsInline
                >
                  <source src="/video/IMBUTITO.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
              <div className="p-8 bg-white rounded-xl shadow-lg transition-shadow duration-300 transform hover:shadow-2xl hover:-translate-y-1">
                <h4 className="mb-3 text-xl font-semibold text-indigo-700">
                  Progettazione 3D Avanzata
                </h4>
                <p className="mb-4 text-gray-600">
                  Utilizziamo tecnologia 3D parametrica all'avanguardia con
                  quattro postazioni CAD-CAM Visi per una progettazione precisa
                  e flessibile.
                </p>
                <img 
                  src="/images/progettazione.jpg" 
                  alt="Progettazione 3D Avanzata"
                  className="object-cover w-full h-48 rounded-lg"
                />
              </div>
              <div className="p-8 bg-white rounded-xl shadow-lg transition-shadow duration-300 transform hover:shadow-2xl hover:-translate-y-1">
                <h4 className="mb-3 text-xl font-semibold text-indigo-700">
                  Prototipazione Veloce
                </h4>
                <p className="mb-4 text-gray-600">
                  Offriamo servizi di prototipazione rapida in lamiera,
                  alluminio e composito, ideali per avanserie e attrezzamenti
                  per bassi volumi di produzione.
                </p>
                <video 
                  className="object-cover w-full h-48 rounded-lg"
                  autoPlay
                  loop
                  muted
                  playsInline
                >
                  <source src="/video/Laser.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </section>

          {/* Synergy Quote Section */}
          <section className="p-8 my-16 text-white bg-indigo-600 rounded-2xl sm:p-12 md:my-20">
            <blockquote className="text-center">
              <p className="text-2xl italic font-medium leading-relaxed sm:text-3xl">
                "La sinergia tra Ufficio Tecnico ed officina è il nostro punto
                di forza. Permette un controllo continuo sul processo e una
                gestione agile delle modifiche richieste dal cliente."
              </p>
            </blockquote>
          </section>

          {/* Equipment & Quality Section */}
          <section className="grid gap-10 items-start md:grid-cols-5">
            <div className="p-8 bg-white rounded-xl shadow-lg md:col-span-3">
              <h3 className="mb-6 text-2xl font-bold text-gray-900 sm:text-3xl">
                Tipologie di Attrezzature
              </h3>
              <ul className="space-y-4 text-gray-700">
                <li className="flex items-start">
                  <span className="mt-1 mr-3 text-green-500">&#10003;</span>
                  <span>Stampi progressivi sino a 2,5 m di lunghezza</span>
                </li>
                <li className="flex items-start">
                  <span className="mt-1 mr-3 text-green-500">&#10003;</span>
                  <span>
                    Stampi a blocco e di trancia (semplice, a passo, a doppio
                    effetto)
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="mt-1 mr-3 text-green-500">&#10003;</span>
                  <span>Stampi di piega di ogni genere</span>
                </li>
                <li className="flex items-start">
                  <span className="mt-1 mr-3 text-green-500">&#10003;</span>
                  <span>Prototipi con attrezzature pilota</span>
                </li>
                <li className="flex items-start">
                  <span className="mt-1 mr-3 text-green-500">&#10003;</span>
                  <span>Saldature a punti e proiezione</span>
                </li>
                
                <li className="flex items-start">
                  <span className="mt-1 mr-3 text-green-500">&#10003;</span>
                  <span>Elettroerosioni a filo</span>
                </li>
                <li className="flex items-start">
                  <span className="mt-1 mr-3 text-green-500">&#10003;</span>
                  <span>Taglio laser</span>
                </li>
                <li className="flex items-start">
                  <span className="mt-1 mr-3 text-green-500">&#10003;</span>
                  <span>Piegatrice</span>
                </li>
                <li className="flex items-start">
                  <span className="mt-1 mr-3 text-green-500">&#10003;</span>
                  <span>Troncatrice</span>
                </li>
              </ul>
            </div>
            <div className="p-8 bg-gray-100 rounded-xl border border-gray-200 md:col-span-2">
              <h3 className="mb-6 text-2xl font-bold text-gray-900 sm:text-3xl">
                Controllo Qualità
              </h3>
              <p className="mb-5 text-gray-600">
                I particolari vengono collaudati con una macchina di misura{" "}
                <span className="font-semibold text-indigo-600">
                  CMM DEA Scirocco e Scanner 3D Leonardo
                </span>
                .
              </p>
              <div className="pt-5 mb-4 space-y-2 text-gray-700 border-t border-gray-300">
                <p className="font-medium">› Controllo Qualitativo completo</p>
              </div>
              <video 
                className="object-cover w-full h-48 rounded-lg"
                autoPlay
                loop
                muted
                playsInline
              >
                <source src="/video/scansione-tag.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Elpa;